module.exports = "/assets/data/b9d3b3477fd4b212b9115284b30e1fbb-RM18.data.json";